import { LiteTradePortfolioListItemStyled } from './styled/LiteTradePortfolioStyled';
import IconAsset from '../../../../components/icon/IconAsset';
import { useCallback, useMemo } from 'react';
import amountFormat from '../../../../utils/amountFormat';
import LiteTradePortfolioPositionInfo from './LiteTradePortfolioPositionInfo';
import { makeSelectLiteTradeMarketDataBySymbol } from '../../liteTradeSelectors';
import { LITE_TRADE_POSITION_SIDE } from '../../liteTradeConstants';
import classNames from 'classnames';
import type { ILiteTradeAssetSymbol, ILiteTradePortfolioPosition } from '../../types/liteTradeReducer.t';
import { useSelectorWithDebounced } from '../../../../hooks/useSelectorWithDebounced';
import LiteTradePortfolioRowPlAnimationWrapper
    from './LiteTradePortfolioRowPlAnimationWrapper/LiteTradePortfolioRowPlAnimationWrapper';

interface ILiteTradePortfolioPositionRowProps {
    from: 'assetInfo' | 'portfolio',
    item: ILiteTradePortfolioPosition,
    symbol: ILiteTradeAssetSymbol,
}

const LiteTradePortfolioPositionRow = ({ symbol, item, from }: ILiteTradePortfolioPositionRowProps) => {
    const marketDataSymbol = useSelectorWithDebounced(makeSelectLiteTradeMarketDataBySymbol(symbol));

    const getCurrentPrice = useCallback((forPl = false) => {
        let side = item.side === LITE_TRADE_POSITION_SIDE.BUY ? 'ask' : 'bid';
        if (forPl) side = side === 'ask' ? 'bid' : 'ask';
        return marketDataSymbol?.[side] ?? 0;
    }, [item.side, marketDataSymbol]);

    const getOpenMargin = useMemo(() => {
        const amount = item.assetInstance.lotsToAmount(item.quantity / item.assetInstance.getLotSize(), getCurrentPrice());
        return amount === null ? '-' : amountFormat(item.assetInstance.lotsToAmount(item.quantity / item.assetInstance.getLotSize(), getCurrentPrice()), 2, '$', false, {
            toFixed: true,
        });
    }, [getCurrentPrice, item]);

    const plAmount = useMemo(() => {
        const price = getCurrentPrice(true);
        if (!price) {
            return null;
        }
        return item.assetInstance.getPositionPL(item, price);
    }, [getCurrentPrice, item]);

    const plComponent = useMemo(() => {
        return plAmount !== null && <span>
            {amountFormat(plAmount, 2, '$', false, {
                toFixed: true,
            })}
        </span>;
    }, [plAmount]);

    return <LiteTradePortfolioListItemStyled className={classNames({
        'inactive': !item.assetInstance.isTradingNow(),
    })}>
        <div className="col-left"><IconAsset symbol={item.symbol}/></div>
        <div className="col-center">
            <div className={'f16'}>{item.assetInstance.asset.info.description}</div>
            <div className={'asset-row-info f14 fw600 text-secondary'}>
                <LiteTradePortfolioPositionInfo
                    item={item}
                    hideSymbol={from !== 'portfolio'}
                />
            </div>
        </div>
        <div className="col-right">
            <div className={'f16 fw600'}>{getOpenMargin}</div>
            <div className={'f14 fw600 position-relative'}>
                <LiteTradePortfolioRowPlAnimationWrapper
                    observerRootMargin={from === 'portfolio'
                        ? '0px 0px -60px 0px' // bottom menu height
                        : '0px 0px -133px 0px' // bottom trading block height
                    }
                    item={item}
                    plAmount={plAmount}
                >
                    {plComponent}
                </LiteTradePortfolioRowPlAnimationWrapper>
            </div>
        </div>
    </LiteTradePortfolioListItemStyled>;
};


export default LiteTradePortfolioPositionRow;
